<template>
    <div>
        <a-transfer
            :data-source="mockData"
            show-search
            :titles="['全部机器人','现有机器人']"
            :list-style="{
            width: '300px',
            height: '400px',
            }"
            :operations="['add', 'delete']"
            :target-keys="targetKeys"
            :render="item => `${item.nickname}(${item.username})`"
            @change="handleChange"
            :lazy=false
        >
            <span slot="notFoundContent">
            没数据
            </span>
            
        </a-transfer>
        <!-- <a-button type="default">Go back</a-button> -->
        <a-button type="primary" class="setButton" @click="batchAddBot()">Set!</a-button>
    </div>
</template>
<script>
const axios = require('axios')
export default {
  props:["currentList", "clientId"],
  inject: ["getAllBotList"],
  data() {
    return {
      ownedBotList: this.currentList,
      allBotList: [],
      mockData: [],   // 左边数据
      targetKeys: [],   // 右边数据
      batchChangedBots: [],
      batchAddBotUrlPostFix: 'UBot/batch_add_bot',
      unbindBotUrlPostFix: 'UBot/unbind_bot',
    };
  },
  computed: {
    batchAddBotUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.batchAddBotUrlPostFix
    },
    unbindBotUrl: function () {
        return global.DOMAIN + global.API_VERSION + this.unbindBotUrlPostFix
    },
  },
  created() {
    this.ownedBotList = this.currentList,
    this.allBotList = this.getAllBotList();
    this.prepareDataForTransferTable();
  },
  methods: {
    handleChange(targetKeys, direction, moveKeys) {
        console.log(targetKeys, direction, moveKeys);
        this.targetKeys = targetKeys;
    },
    prepareDataForTransferTable() {
        const leftData = []
        const oriTargetData = []
        const owned = []
        this.ownedBotList.forEach(function(item){
            owned.push(item.username)
        })
        console.log("owned: ", owned)
        this.allBotList.forEach(function(item){
            leftData.push({
                key: item.username,
                nickname: item.nickname,
                username: item.username,
                title: "title",
                description: "discription",
                disabled: false,
                // avatar_url: item.avatar_url
            }) 
            if(owned.indexOf(item.username) != -1){
                oriTargetData.push(item.username)
            }   
        })
        // this.currentList.forEach(function(item){
        //     oriTargetData.push(item.username)
        // })
        this.mockData = leftData
        this.targetKeys = owned
        console.log(this.mockData)
        console.log(this.targetKeys)
    },
    batchAddBot(){
        console.log("batch add bot")
        const ownedBotUsernameList = []   // 目前已有的机器人
        const batchChangedBots = []   // 通过穿梭框增加的机器人
        const deletedBotsUsernameList = []   // 通过穿梭框删除的机器人

        this.ownedBotList.forEach(function(item){
            ownedBotUsernameList.push(item.username)
        })
        console.log("ownedBotUsernameList", ownedBotUsernameList)
        this.targetKeys.forEach(function(item){    // 从穿梭框右框中取出以前没有的机器人，添加
            if(ownedBotUsernameList.indexOf(item) == -1){
                batchChangedBots.push(item)
            }
        })
        this.batchChangedBots = batchChangedBots
        console.log("batchChangedBots", this.batchChangedBots)

        axios.post(this.batchAddBotUrl, {  // 批量添加机器人
        bot_username_list: this.batchChangedBots,
        client_id: this.clientId,
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            console.log('添加 Bot 成功')
            window.alert('操作成功')
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
          else{
              console.log(data.data.err_code)
          }
        })
        var targetKeys = this.targetKeys
        ownedBotUsernameList.forEach(function(item){
            if(targetKeys.indexOf(item) == -1){
                deletedBotsUsernameList.push(item)
            }
        })
        
        console.log("deletedBotsUsernameList: ", deletedBotsUsernameList)
        var boolResult = true;
        if(deletedBotsUsernameList.length != 0){
            for(var index=0; index<deletedBotsUsernameList.length; ++index){
                var res = true
                console.log(deletedBotsUsernameList[index])
                res = this.deleteBot(deletedBotsUsernameList[index])
                boolResult = boolResult && res
            }
            console.log("boolResult: ", boolResult)  
        }

        this.$emit("changeCurrentBotList", this.targetKeys)  // 传到 bot-list 组件
        this.$emit("refresh", this.targetKeys) // 传到 client-manage 组件
    },
    deleteBot(botUsername) {
        axios.post(this.unbindBotUrl, {
                    bot_username: botUsername,
                    client_id: this.clientId,
                    token: sessionStorage.token
                }).then((data) => {
                    if(data.data.err_code == 0){
                        console.log("删除机器人：", botUsername)
                        window.alert("删除机器人：" + botUsername)
                        return true
                    }
                    else{
                        console.log(data.data.err_code)
                        return false
                    }
                })
    }
    
  },
};
</script>
<style>
    .setButton{
        float: right;
    }
</style>